import request from '@/utils/request'
import type * as ConfigType from '@/typings/config'
import type * as System from '@/typings/system'
import type { CommonRes } from '@/typings'
import type { IConfigDetail } from '@/typings/config'
import type { IShortLinkInfo } from '@/typings/system'

/**
 * 数组配置
 */

interface IGetConfigListParams {
  keyword: string
  page: number
  size: number
}
// 数组列表
export async function getConfigList(params: IGetConfigListParams) {
  return request('/api/v2/system/config_list', {
    method: 'GET',
    data: params
  })
}

interface ISaveConfigParams {
  info: ConfigType.ConfigDetailType
}
// 数组修改/新建
export async function saveConfig(params: ISaveConfigParams) {
  return request('/api/v2/system/config_save', {
    method: 'POST',
    data: params
  })
}

interface IDeleteConfig {
  id: number
}
// 数组删除
export async function deleteConfig(params: IDeleteConfig) {
  return request('/api/v2/system/config_delete', {
    method: 'POST',
    data: params
  })
}

/**
 * 数组明细
 */
interface IGetConfigDetailListParams {
  keyword?: string
  page?: number
  size?: number
  config_code?: string
}
// 数组明细列表
export async function getSystemConfigDetailList(params: IGetConfigDetailListParams) {
  return request<CommonRes<{ list: IConfigDetail[]; parent_list: IConfigDetail[] }>>(
    '/api/v2/system/config_detail_list',
    {
      method: 'GET',
      data: params
    }
  )
}

interface ISaveConfigDetailParams {
  info: ConfigType.ConfigDataDetailType
}
// 数组明细修改/新建
export async function saveConfigDetail(params: ISaveConfigDetailParams) {
  return request('/api/v2/system/config_detail_save', {
    method: 'POST',
    data: params
  })
}

interface IDeleteConfigDetailParams {
  id: number
}
// 数组明细删除
export async function deleteConfigDetail(params: IDeleteConfigDetailParams) {
  return request('/api/v2/system/config_detail_delete', {
    method: 'POST',
    data: params
  })
}

interface IGetProjectFundListRequest {
  currency?: string
  fund?: string
  fund_group?: string
  page?: number
  size?: number
  sort?: string
}
// 获取基金配置列表
export async function getProjectFundList(params: IGetProjectFundListRequest) {
  return request('/api/v2/project/fund/search', {
    method: 'GET',
    data: params
  })
}

interface IDelProjectFundRequest {
  id?: number
}
// 删除基金配置
export async function delProjectFund(params: IDelProjectFundRequest) {
  return request('/api/v2/project/fund/delete', {
    method: 'POST',
    data: params
  })
}

interface IGetProjectFundInfoRequest {
  id?: number
}
// 获取基金配置详情
export async function getProjectFundInfo(params: IGetProjectFundInfoRequest) {
  return request('/api/v2/project/fund/get', {
    method: 'GET',
    data: params
  })
}

interface IGetProjectFundOptionRequest {
  need_fund_entity?: number
}
// captable获取基金选项
export async function getProjectFundOption(params: IGetProjectFundOptionRequest) {
  return request('/api/v2/project/fund/list_option', {
    method: 'GET',
    data: params
  })
}

interface ISaveProjectFundRequest {
  fund?: System.SaveFundParams
}
// 保存基金配置详情
export async function saveProjectFund(params: ISaveProjectFundRequest) {
  return request('/api/v2/project/fund/save', {
    method: 'POST',
    data: params
  })
}

interface IShortUrlEncryptRequest {
  long_url?: string
}
// 字符串加密
export async function shortUrlEncrypt(params: IShortUrlEncryptRequest) {
  return request('/api/v2/system/short_url_encrypt', {
    method: 'POST',
    data: params
  })
}

interface ICreateShortLinkRequestParams {
  long_url?: string
}
// 创建短链接
export async function apiCreateShortLink(params: ICreateShortLinkRequestParams) {
  return request<CommonRes<{ info: IShortLinkInfo }>>('/api/v2/system/short_link/create', {
    method: 'POST',
    data: params
  })
}

interface IGetConfigDetailTreeRequest {
  config_code?: string
  is_need_config?: number
}
// 获取数组配置详情树结构
export async function getConfigDetailTree(params: IGetConfigDetailTreeRequest) {
  return request('/api/v2/system/config_detail_tree', {
    method: 'GET',
    data: params
  })
}

interface IConfigDetailBatchSaveRequest {
  config_code?: string
  add_list: ConfigType.IConfigDataNode[]
  update_list: ConfigType.IConfigDataNode[]
  delete_ids: number[]
}
// 数组配置详情树批量保存
export async function configDetailBatchSave(params: IConfigDetailBatchSaveRequest) {
  return request('/api/v2/system/config_detail_batch_save', {
    method: 'POST',
    data: params
  })
}
